// extracted by mini-css-extract-plugin
module.exports = {"app":"_3FKk97jFiw7a9Zn5RvgieX","content":"xcxECzwooP2uihxRapYhf"};